import axios from 'axios'

async function send(data) {
  const BASE_URL = process.env.NEXT_PUBLIC_LIVE_URL

  let { userId, clientId, events, debug = false } = data?.google
  const posthogData = data?.posthog ?? null

  if (!Array.isArray(events)) {
    events = [events]
  }

  try {
    const res = await axios.post(`${BASE_URL}/api/measurement`, {
      google: {
        userId,
        clientId,
        events,
        debug
      },
      posthog: posthogData
    })

    return res.data
  } catch (e) {
    return [null, e]
  }
}

export default { send }
